import type {
  LanguageServiceProvider,
  LanguageServiceCompletionResult,
} from './languageServiceProvider';

export const noopLanguageServiceProvider: LanguageServiceProvider = {
  engine: 'noop',
  ensureInitialized: async () => {},
  registerDocument: async () => true,
  updateDocument: async () => true,
  closeDocument: async () => true,
  connectForLanguageServices: async () => false,
  disconnectForLanguageServices: async () => true,
  getCompletionItems: async (): Promise<LanguageServiceCompletionResult> => ({ items: [] }),
  getHoverInfo: async () => null,
  getSignatureHelp: async () => null,
};

